import { Language } from '../translations'

export const settingsTranslations: Record<string, Record<Language, string>> = {
    cvSettings: {
        en: 'CV Settings',
        fi: 'CV-asetukset'
    },
    users: {
        en: 'Users',
        fi: 'Käyttäjät'
    },
    confirmSetRole: {
        en: 'Confirm remove admin',
        fi: 'Vahvista adminin poisto'
    },
    setRoleConfirmation: {
        en: 'Are you sure you want to remove your own admin access? You cannot change roles or access settings after this.',
        fi: 'Haluatko varmasti poistaa itseltäsi admin-oikeudet? Et pääse muuttamaan rooleja ja asetuksia tämän jälkeen.'
    },
    mustHaveRole: {
        en: 'Users must have at least one role',
        fi: 'Käyttäjillä täytyy olla vähintään yksi rooli'
    },
    companyLogo: {
        en: 'Company Logo',
        fi: 'Yrityksen logo'
    },
    companyLogoDescription: {
        en: 'Upload your company logo in PNG format. This logo will be used in all generated CVs.',
        fi: 'Lataa yrityksesi logo PNG-muodossa. Tätä logoa käytetään kaikissa luoduissa ansioluetteloissa.'
    },
    currentLogo: {
        en: 'Current Logo',
        fi: 'Nykyinen logo'
    },
    filename: {
        en: 'Filename',
        fi: 'Tiedostonimi'
    },
    lastModified: {
        en: 'Last Modified',
        fi: 'Viimeksi muokattu'
    },
    noLogoUploaded: {
        en: 'No company logo has been uploaded yet.',
        fi: 'Yrityksen logoa ei ole vielä ladattu.'
    },
    uploadNewLogo: {
        en: 'Upload New Logo',
        fi: 'Lataa uusi logo'
    },
    onlyPngAllowed: {
        en: 'Only PNG files are allowed',
        fi: 'Vain PNG-tiedostot ovat sallittuja'
    },
    preview: {
        en: 'Preview',
        fi: 'Esikatselu'
    },
    uploading: {
        en: 'Uploading...',
        fi: 'Ladataan...'
    },
    uploadLogo: {
        en: 'Upload Logo',
        fi: 'Lataa logo'
    },
    selectFileFirst: {
        en: 'Please select a file first',
        fi: 'Valitse ensin tiedosto'
    },
    logoUploadedSuccess: {
        en: 'Logo uploaded successfully',
        fi: 'Logo ladattu onnistuneesti'
    },
    changeLogo: {
        en: 'Change Logo',
        fi: 'Vaihda logo'
    },
    backToMainView: {
        en: 'Back',
        fi: 'Takaisin'
    },
    adminConfiguration: {
        en: 'Template Configuration',
        fi: 'Mallin Asetukset',
    },
    adminConfigurationDescription: {
        en: 'Customize the appearance of the CV template',
        fi: 'Mukauta CV-mallin ulkoasua',
    },
    backgroundColor: {
        en: 'Background Color',
        fi: 'Taustaväri',
    },
    textColor: {
        en: 'Text Color',
        fi: 'Tekstin Väri',
    },
    mainColor: {
        en: 'Main Color',
        fi: 'Pääväri',
    },
    saveConfiguration: {
        en: 'Save Configuration',
        fi: 'Tallenna asetukset',
    },
    adminConfigSaved: {
        en: 'Configuration saved successfully',
        fi: 'Asetukset tallennettu onnistuneesti',
    },
    settings: {
        en: 'Settings',
        fi: 'Asetukset'
    },
    generalSettings: {
        en: 'General Settings',
        fi: 'Yleiset asetukset'
    },
    salarySettings: {
        en: 'Salary Settings',
        fi: 'Palkka-asetukset'
    },
    instructions: {
        en: 'Instructions and announcements',
        fi: 'Ohjeet ja tiedotteet'
    },
    aiSettings: {
        en: 'AI Settings',
        fi: 'Tekoälyn asetukset'
    },
    aiPromptConfiguration: {
        en: 'AI Prompt Configuration',
        fi: 'Tekoälyn kehoteasetukset'
    },
    aiPromptConfigurationDescription: {
        en: 'Configure the prompts used by AI for CV parsing, introduction generation, search result parsing and the chatbot',
        fi: 'Määritä tekoälyn käyttämät kehotteet CV:n jäsentämiseen, esittelyn luomiseen, hakutulosten jäsentämiseen ja chatbotille'
    },
    searchAiPrompt: {
        en: 'Search AI Prompt',
        fi: 'Tekoälyn kehote hakuun'
    },
    searchAiPromptPlaceholder: {
        en: 'Enter search AI prompt',
        fi: 'Syötä tekoälyn kehote hakuun'
    },
    searchAiPromptHint: {
        en: 'Prompt used by AI for parsing search results',
        fi: 'Kehote, jota tekoäly käyttää hakutulosten jäsentämiseen'
    },
    cvAiPrompt: {
        en: 'CV AI Prompt',
        fi: 'Tekoälyn kehote CV:lle'
    },
    cvAiPromptPlaceholder: {
        en: 'Enter CV AI prompt',
        fi: 'Syötä tekoälyn kehote CV:lle'
    },
    cvAiPromptHint: {
        en: 'Prompt used by AI for CV parsing',
        fi: 'Kehote, jota tekoäly käyttää CV:n jäsentämiseen'
    },
    introductionAiPrompt: {
        en: 'Introduction AI Prompt',
        fi: 'Tekoälyn kehote esittelyyn'
    },
    introductionAiPromptPlaceholder: {
        en: 'Enter introduction AI prompt',
        fi: 'Syötä tekoälyn kehote esittelyyn'
    },
    introductionAiPromptHint: {
        en: 'Prompt used by AI for introduction generation',
        fi: 'Kehote, jota tekoäly käyttää esittelyn luomiseen'
    },
    chatAiPrompt: {
        en: 'Chatbot AI Prompt',
        fi: 'Tekoälyn kehote chatbotille'
    },
    chatAiPromptPlaceholder: {
        en: 'Enter chatbot AI prompt',
        fi: 'Syötä tekoälyn kehote chatbotille'
    },
    chatAiPromptHint: {
        en: 'Prompt used by AI for chatbot interactions',
        fi: 'Kehote, jota tekoäly käyttää chatbotissa'
    },
    llmSettings: {
        en: 'LLM Settings',
        fi: 'LLM-asetukset'
    },
    llmProviderConfiguration: {
        en: 'LLM Provider Configuration',
        fi: 'LLM-palveluntarjoajan asetukset'
    },
    llmProviderConfigurationDescription: {
        en: 'Configure the provider and model used by LLM',
        fi: 'Määritä LLM:n käyttämä palveluntarjoaja ja malli'
    },
    provider: {
        en: 'Provider',
        fi: 'Palveluntarjoaja'
    },
    model: {
        en: 'Model',
        fi: 'Malli'
    },
    selectProvider: {
        en: 'Select provider',
        fi: 'Valitse palveluntarjoaja'
    },
    customProviderUrl: {
        en: 'Custom Provider URL',
        fi: 'Mukautettu palveluntarjoajan URL'
    },
    cvParsingLLM: {
        en: 'CV Parsing LLM',
        fi: 'LLM CV:n jäsentämiseen'
    },
    embeddingLLM: {
        en: 'Embedding LLM',
        fi: 'LLM upottamista varten'
    },
    searchLLM: {
        en: 'Search LLM',
        fi: 'LLM hakuun'
    },
    introductionLLM: {
        en: 'Introduction Generation LLM',
        fi: 'LLM esittelyn luomiseen'
    },
    chatLLM: {
        en: 'Chatbot LLM',
        fi: 'LLM chatbotille'
    },
    hanselLLM: {
        en: 'Hansel (Bill Verification) LLM',
        fi: 'Hansel (Laskun varmennus) LLM'
    },
    hanselLLMDescription: {
        en: 'LLM used for bill data verification',
        fi: 'Laskujen tietojen varmennukseen käytettävä LLM'
    },
    hanselAiPrompt: {
        en: 'Hansel AI Prompt',
        fi: 'Tekoälyn kehote Hanselille'
    },
    hanselAiPromptPlaceholder: {
        en: 'Enter Hansel AI prompt',
        fi: 'Syötä tekoälyn kehote Hanselille'
    },
    hanselAiPromptHint: {
        en: 'Prompt used by AI for bill data verification',
        fi: 'Kehote, jota tekoäly käyttää laskujen tietojen varmennukseen'
    },
    newHanselPromptCreated: {
        en: 'New Hansel prompt created successfully',
        fi: 'Uusi Hansel-kehote luotu'
    },
    hanselPromptUpdated: {
        en: 'Hansel prompt updated successfully',
        fi: 'Hansel-kehote päivitetty'
    },
    errorSavingHanselPrompt: {
        en: 'Error saving Hansel prompt',
        fi: 'Virhe Hansel-kehotteen tallennuksessa'
    },
    hanselPromptDeleted: {
        en: 'Hansel prompt deleted successfully',
        fi: 'Hansel-kehote poistettu'
    },
    errorDeletingHanselPrompt: {
        en: 'Error deleting Hansel prompt',
        fi: 'Virhe Hansel-kehotteen poistossa'
    },
    selectModel: {
        en: 'Select model',
        fi: 'Valitse malli'
    },
    apiKey: {
        en: 'API Key',
        fi: 'API-avain'
    },
    historyLength: {
        en: 'Chat History Length',
        fi: 'Chat-historian pituus'
    },
    enterModelName: {
        en: 'Enter model name',
        fi: 'Syötä mallin nimi'
    },
    enterApiKey: {
        en: 'Enter API key',
        fi: 'Syötä API-avain'
    },
    positionalParams: {
        en: 'Parameters',
        fi: 'Parametrit'
    },
    positionalParamsHint: {
        en: 'Comma separated list of parameters ($input = input/prompt)',
        fi: 'Pilkulla erotettu lista parametreistä ($input = input/kehote)'
    },
    newPrompt: {
        en: 'New Prompt',
        fi: 'Uusi kehote'
    },
    promptName: {
        en: 'Prompt Name',
        fi: 'Kehotteen nimi'
    },
    enterPromptName: {
        en: 'Enter prompt name',
        fi: 'Lisää kehotteen nimi'
    },
    pleaseEnterName: {
        en: 'Please enter a name for the new prompt',
        fi: 'Anna nimi uudelle kehotteelle'
    },
    newSearchPromptCreated: {
        en: 'New search prompt created successfully',
        fi: 'Uusi hakukehote luotu'
    },
    searchPromptUpdated: {
        en: 'Search prompt updated successfully',
        fi: 'Hakukehote päivitetty'
    },
    errorSavingSearchPrompt: {
        en: 'Error saving search prompt',
        fi: 'Virhe hakukehotteen tallennuksessa'
    },
    newCvPromptCreated: {
        en: 'New CV prompt created successfully',
        fi: 'Uusi CV-kehote luotu'
    },
    cvPromptUpdated: {
        en: 'CV prompt updated successfully',
        fi: 'CV-kehote päivitetty'
    },
    errorSavingCvPrompt: {
        en: 'Error saving CV prompt',
        fi: 'Virhe CV-kehoteen tallennuksessa'
    },
    newIntroductionPromptCreated: {
        en: 'New introduction prompt created successfully',
        fi: 'Uusi esittelykehotus luotu'
    },
    introductionPromptUpdated: {
        en: 'Introduction prompt updated successfully',
        fi: 'Esittelykehotus päivitetty'
    },
    errorSavingIntroductionPrompt: {
        en: 'Error saving introduction prompt',
        fi: 'Virhe esittelykehotteen tallennuksessa'
    },
    newChatPromptCreated: {
        en: 'New chatbot prompt created successfully',
        fi: 'Uusi chatbot-kehote luotu'
    },
    chatPromptUpdated: {
        en: 'Chatbot prompt updated successfully',
        fi: 'Chatbot-kehote päivitetty'
    },
    newProjectsPromptCreated: {
        en: 'New projects view expert search prompt created successfully',
        fi: 'Uusi projektinäkymän asiantuntijahaku -kehote luotu'
    },
    projectsPromptUpdated: {
        en: 'Projects view expert search prompt updated successfully',
        fi: 'Projektinäkymän asiantuntijahaku -kehote päivitetty'
    },
    errorSavingProjectsPrompt: {
        en: 'Error saving projects view expert search prompt',
        fi: 'Virhe projektinäkymän asiantuntijahaku -kehotteen tallennuksessa'
    },
    errorSavingChatPrompt: {
        en: 'Error saving chatbot prompt',
        fi: 'Virhe chatbot-kehotteen tallennuksessa'
    },
    searchPromptDeleted: {
        en: 'Search prompt deleted successfully',
        fi: 'Hakukehote poistettu'
    },
    errorDeletingSearchPrompt: {
        en: 'Error deleting search prompt',
        fi: 'Virhe hakukehotteen poistossa'
    },
    cvPromptDeleted: {
        en: 'CV prompt deleted successfully',
        fi: 'CV-kehote poistettu'
    },
    errorDeletingCvPrompt: {
        en: 'Error deleting CV prompt',
        fi: 'Virhe CV-kehoteen poistossa'
    },
    introductionPromptDeleted: {
        en: 'Introduction prompt deleted successfully',
        fi: 'Esittelykehotus poistettu'
    },
    errorDeletingIntroductionPrompt: {
        en: 'Error deleting introduction prompt',
        fi: 'Virhe esittelykehotteen poistossa'
    },
    chatPromptDeleted: {
        en: 'Chatbot prompt deleted successfully',
        fi: 'Chatbot-kehote poistettu'
    },
    projectsPromptDeleted: {
        en: 'Projects view expert search prompt deleted successfully',
        fi: 'Projektinäkymän asiantuntijahaku -kehote poistettu'
    },
    errorDeletingChatPrompt: {
        en: 'Error deleting chatbot prompt',
        fi: 'Virhe chatbot-kehotteen poistossa'
    },
    errorDeletingProjectsPrompt: {
        en: 'Error deleting projects view expert search prompt',
        fi: 'Virhe projektinäkymän asiantuntijahaku -kehotteen poistossa'
    },
    errorFetchingPrompts: {
        en: 'Error fetching prompts',
        fi: 'Virhe kehotteiden hakemisessa'
    },
    selectPrompt: {
        en: 'Select prompt',
        fi: 'Valitse kehote'
    },
    pleaseEnterPromptText: {
        en: 'Please enter prompt text',
        fi: 'Anna kehotteelle teksti'
    },
    promptNameAlreadyExists: {
        en: 'Prompt name already exists',
        fi: 'Kehotteen nimi on jo olemassa'
    },
    milvusDatabase: {
        en: 'Milvus Database',
        fi: 'Milvus-tietokanta'
    },
    milvusDatabaseDescription: {
        en: 'Manage CV entries in the Milvus database',
        fi: 'Hallinnoi CV-merkintöjä Milvus-tietokannassa'
    },
    bulkUpload: {
        en: 'Bulk Upload',
        fi: 'Joukkolataus'
    },
    deleteSelected: {
        en: 'Delete Selected',
        fi: 'Poista valitut'
    },
    deleteAll: {
        en: 'Delete All',
        fi: 'Poista kaikki'
    },
    refresh: {
        en: 'Refresh',
        fi: 'Päivitä'
    },
    userId: {
        en: 'User ID',
        fi: 'Käyttäjä-ID'
    },
    content: {
        en: 'Content',
        fi: 'Sisältö'
    },
    actions: {
        en: 'Actions',
        fi: 'Toiminnot'
    },
    entryDetails: {
        en: 'Entry Details',
        fi: 'Merkinnän tiedot'
    },
    confirmDeleteEntry: {
        en: 'Are you sure you want to delete this entry?',
        fi: 'Haluatko varmasti poistaa tämän merkinnän?'
    },
    confirmDeleteAllEntries: {
        en: 'Are you sure you want to delete ALL entries? This cannot be undone.',
        fi: 'Haluatko varmasti poistaa KAIKKI merkinnät? Tätä ei voi kumota.'
    },
    confirmDeleteSelectedEntries: {
        en: 'Are you sure you want to delete selected entries?',
        fi: 'Haluatko varmasti poistaa valitut merkinnät?'
    },
    entryDeleted: {
        en: 'Entry deleted successfully',
        fi: 'Merkintä poistettu onnistuneesti'
    },
    allEntriesDeleted: {
        en: 'All entries deleted successfully',
        fi: 'Kaikki merkinnät poistettu onnistuneesti'
    },
    selectedEntriesDeleted: {
        en: 'Selected entries deleted successfully',
        fi: 'Valitut merkinnät poistettu onnistuneesti'
    },
    noEntriesSelected: {
        en: 'No entries selected for deletion',
        fi: 'Ei valittuja merkintöjä poistettavaksi'
    },
    noEntriesFound: {
        en: 'No entries found in the database',
        fi: 'Tietokannasta ei löytynyt merkintöjä'
    },
    someFilesFailedToUpload: {
        en: 'Some files failed to upload. Check console for details.',
        fi: 'Joitain tiedostoja ei voitu ladata. Tarkista konsoli saadaksesi lisätietoja.'
    },
    databaseEntries: {
        en: 'Database Entries',
        fi: 'Tietokannan merkinnät'
    },
    noEntriesInDatabase: {
        en: 'No entries in the database',
        fi: 'Ei merkintöjä tietokannassa'
    },
    viewContent: {
        en: 'View Content',
        fi: 'Näytä sisältö'
    },
    hideContent: {
        en: 'Hide Content',
        fi: 'Piilota sisältö'
    },
    warning: {
        en: 'Warning',
        fi: 'Varoitus'
    },
    deleteAllWarning: {
        en: 'This is a destructive action',
        fi: 'Tämä on tuhoava toiminto'
    },
    deleteAllConsequences: {
        en: 'This will permanently delete ALL entries from the Milvus database. This operation cannot be undone.',
        fi: 'Tämä poistaa pysyvästi KAIKKI merkinnät Milvus-tietokannasta. Tätä toimintoa ei voi kumota.'
    },
    typeToConfirm: {
        en: 'Type to confirm:',
        fi: 'Kirjoita vahvistaaksesi:'
    },
    confirmationTextMismatch: {
        en: 'The confirmation text does not match. Please type exactly "DELETE"',
        fi: 'Vahvistusteksti ei täsmää. Kirjoita tarkasti "DELETE"'
    },
    deleteAllEntries: {
        en: 'Delete All Entries',
        fi: 'Poista kaikki merkinnät'
    },
    confirmDelete: {
        en: 'Confirm Delete',
        fi: 'Vahvista poisto'
    },
    deleteEntryConfirmation: {
        en: 'Are you sure you want to delete this entry? This cannot be undone.',
        fi: 'Haluatko varmasti poistaa tämän merkinnän? Toimintoa ei voi kumota.'
    },
    delete: {
        en: 'Delete',
        fi: 'Poista'
    },
    deleting: {
        en: 'Deleting...',
        fi: 'Poistetaan...'
    },
    cancel: {
        en: 'Cancel',
        fi: 'Peruuta'
    },
    deleteAllEntriesConfirmation: {
        en: 'To confirm deletion of ALL entries, please type the text below:',
        fi: 'Vahvistaaksesi KAIKKIEN merkintöjen poistamisen, kirjoita alla oleva teksti:'
    },
    allEntriesDeletedSuccessfully: {
        en: 'All entries deleted successfully',
        fi: 'Kaikki merkinnät poistettu onnistuneesti'
    },
    entryDeletedSuccessfully: {
        en: 'Entry deleted successfully',
        fi: 'Merkintä poistettu onnistuneesti'
    },
    error: {
        en: 'Error',
        fi: 'Virhe'
    },
    success: {
        en: 'Success',
        fi: 'Onnistui'
    },
    reEmbedAll: {
        en: 'Re-embed All',
        fi: 'Upota kaikki uudelleen'
    },
    reEmbedSelected: {
        en: 'Re-embed Selected',
        fi: 'Upota valitut uudelleen'
    },
    reEmbedding: {
        en: 'Re-embedding...',
        fi: 'Upotetaan...'
    },
    confirmCreateTestUsers: {
        en: 'Confirm Create Test Users',
        fi: 'Vahvista testikäyttäjien luominen'
    },
    createTestUsersConfirmation: {
        en: 'Are you sure you want to create test users? This will create users from milvus test data (ids 1000 and above).',
        fi: 'Haluatko varmasti luoda testikäyttäjiä? Tämä luo käyttäjiä milvus-testidatasta (id:t 1000 ja yli).'
    },
    createTestUsersFromSelectedConfirmation: {
        en: 'Are you sure you want to create test users from selected entries? This will create users only for the selected entries.',
        fi: 'Haluatko varmasti luoda testikäyttäjiä valituista merkinnöistä? Tämä luo käyttäjiä vain valituille merkinnöille.'
    },
    createTestUsers: {
        en: 'Create Test Users',
        fi: 'Luo testikäyttäjiä'
    },
    createTestUsersFromSelected: {
        en: 'Create Test Users from Selected',
        fi: 'Luo testikäyttäjiä valituista'
    },
    creatingTestUsers: {
        en: 'Creating test users...',
        fi: 'Luodaan testikäyttäjiä...'
    },
    confirmReEmbed: {
        en: 'Confirm Re-embed All',
        fi: 'Vahvista kaikkien upottaminen uudelleen'
    },
    reEmbedAllConfirmation: {
        en: 'Are you sure you want to re-embed all entries using',
        fi: 'Haluatko varmasti upottaa kaikki merkinnät uudelleen käyttäen'
    },
    reEmbedSelectedConfirmation: {
        en: 'Are you sure you want to re-embed selected entries using',
        fi: 'Haluatko varmasti upottaa valitut merkinnät uudelleen käyttäen'
    },
    cvParsingLLMDescription: {
        en: 'LLM used for CV parsing',
        fi: 'CV:n jäsentämiseen käytettävä LLM'
    },
    introductionLLMDescription: {
        en: 'LLM used for generating introductions',
        fi: 'Esittelyjen generointiin käytettävä LLM'
    },
    embeddingLLMDescription: {
        en: 'LLM used for creating embeddings',
        fi: 'Upotusten luontiin käytettävä LLM'
    },
    searchLLMDescription: {
        en: 'LLM used for determining amount of search results',
        fi: 'Hakutulosten määrän määrittämiseen käytettävä LLM'
    },
    chatLLMDescription: {
        en: 'LLM used for chatbot interactions',
        fi: 'Chatbotissa käytettävä LLM'
    },
    deleteUser: {
        en: 'Delete user',
        fi: 'Poista käyttäjä'
    },
    deleteUserConfirmation: {
        en: 'Are you sure you want to delete user',
        fi: 'Haluatko varmasti poistaa käyttäjän'
    },
    deleteUserTooltip: {
        en: 'Please remove the user\'s roles before deleting',
        fi: 'Poista käyttäjän roolit ennen käyttäjän poistamista'
    },
    userDeleted: {
        en: 'User deleted successfully',
        fi: 'Käyttäjä poistettu onnistuneesti'
    },
    expertTitles: {
        en: 'Expert Titles',
        fi: 'Asiantuntijan tittelit'
    },
    expertTitlesDescription: {
        en: 'Manage the predefined titles that experts can choose from',
        fi: 'Hallinnoi ennalta määritettyjä titteleitä, joista asiantuntijat voivat valita'
    },
    enterNewTitle: {
        en: 'Enter new title...',
        fi: 'Syötä uusi titteli...'
    },
    add: {
        en: 'Add',
        fi: 'Lisää'
    },
    titleAlreadyExists: {
        en: 'Title already exists',
        fi: 'Titteli on jo olemassa'
    },
    titleAddedSuccessfully: {
        en: 'Title added successfully',
        fi: 'Titteli lisätty onnistuneesti'
    },
    failedToAddTitle: {
        en: 'Failed to add title',
        fi: 'Tittelin lisääminen epäonnistui'
    },
    titleRemovedSuccessfully: {
        en: 'Title removed successfully',
        fi: 'Titteli poistettu onnistuneesti'
    },
    failedToRemoveTitle: {
        en: 'Failed to remove title',
        fi: 'Tittelin poistaminen epäonnistui'
    },
    noTitlesConfigured: {
        en: 'No titles configured yet',
        fi: 'Titteleitä ei ole vielä määritetty'
    },
    failedToLoadTitleConfiguration: {
        en: 'Failed to load title configuration',
        fi: 'Tittelin asetusten lataaminen epäonnistui'
    },
    errorUpdatingUserRole: {
        en: 'Error updating user role',
        fi: 'Virhe käyttäjän roolin päivittämisessä'
    },
    failedToLoadUsers: {
        en: 'Failed to load users',
        fi: 'Käyttäjien lataaminen epäonnistui'
    },
    enterTitlesCommaSeparated: {
        en: 'Enter titles (comma-separated)...',
        fi: 'Syötä tittelit (pilkulla erotettuina)...'
    },
    titleOrderUpdated: {
        en: 'Title order updated successfully',
        fi: 'Tittelien järjestys päivitetty onnistuneesti'
    },
    failedToUpdateTitleOrder: {
        en: 'Failed to update title order',
        fi: 'Tittelien järjestyksen päivittäminen epäonnistui'
    },
    titlesAddedSuccessfully: {
        en: 'titles added successfully',
        fi: 'titteliä lisätty onnistuneesti'
    },
    reParseCvs: {
        en: 'Re-parse CVs',
        fi: 'Jäsennä CV:t uudelleen'
    },
    reParseAll: {
        en: 'Re-parse All',
        fi: 'Jäsennä kaikki uudelleen'
    },
    reParseSelected: {
        en: 'Re-parse Selected',
        fi: 'Jäsennä valitut uudelleen'
    },
    reParsing: {
        en: 'Re-parsing...',
        fi: 'Jäsennetään uudelleen...'
    },
    confirmReParse: {
        en: 'Confirm Re-parse',
        fi: 'Vahvista uudelleen jäsentäminen'
    },
    reParseAllConfirmation: {
        en: 'Are you sure you want to re-parse all CV entries? This will update the database with newly parsed data from Milvus',
        fi: 'Haluatko varmasti jäsentää kaikki CV-merkinnät uudelleen? Tämä päivittää tietokannan Milvuksesta uudelleen jäsennetyllä datalla'
    },
    reParseSelectedConfirmation: {
        en: 'Are you sure you want to re-parse selected CV entries? This will update the database with newly parsed data from Milvus',
        fi: 'Haluatko varmasti jäsentää valitut CV-merkinnät uudelleen? Tämä päivittää tietokannan Milvuksesta uudelleen jäsennetyllä datalla'
    },
    workStartDate: {
        en: 'Work Start Date',
        fi: 'Aloituspäivä'
    },
    vacationDays: {
        en: 'Vacation Days',
        fi: 'Vuosiloman määrä'
    },
    workStartDatePlaceholder: {
        en: 'Select date',
        fi: 'Valitse päivämäärä'
    },
    vacationDaysPlaceholder: {
        en: 'Enter vacation days',
        fi: 'Syötä vuosiloman määrä'
    },
    vacationDataUpdated: {
        en: 'Vacation data updated successfully',
        fi: 'Lomatieto päivitetty onnistuneesti'
    },
    failedToUpdateVacationData: {
        en: 'Failed to update vacation data',
        fi: 'Lomatiedon päivittäminen epäonnistui'
    },
    save: {
        en: 'Save',
        fi: 'Tallenna'
    },
    edit: {
        en: 'Edit',
        fi: 'Muokkaa'
    },
    rolesTitle: {
        en: 'Permissions',
        fi: 'Käyttöoikeudet'
    },
    rolesDescription: {
        en: 'Access is granted to the top-level heading in the main navigation. Views under the heading open with the same access.',
        fi: 'Oikeus annetaan päänavigaation ylätason otsikkoon. Otsikon alla olevat näkymät avautuvat samalla oikeudella.'
    },
    searchUsersPlaceholder: {
        en: 'Search by name...',
        fi: 'Hae nimellä...'
    }
};
